/* eslint-disable no-useless-constructor */
import React from "react";
import { connect } from "react-redux";
// Chuyển từ Material-UI v4 sang MUI v5 để loại bỏ cảnh báo findDOMNode
import { Backdrop, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";

// Sử dụng styled API thay cho makeStyles
const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: 99999,
  color: "#fff"
}));

function AppLoading(props) {
  const { loading } = props;

  return (
    <StyledBackdrop open={loading}>
      <CircularProgress color="inherit" />
    </StyledBackdrop>
  );
}

const mapStateToProps = (state) => ({
  loading: state.app.loading,
});

export default connect(mapStateToProps)(AppLoading);
